import { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from './Link'

const LinksList = styled.div`
  position: relative;
`

class Links extends Component {
  render() {
    const { links, deleteLink, updateUserLink, adminLink, registerLinkClick } =
      this.props
    return (
      <LinksList>
        {links.map((link) => (
          <Link
            key={link.id}
            link={link}
            deleteLink={deleteLink}
            updateUserLink={updateUserLink}
            adminLink={adminLink}
            registerLinkClick={registerLinkClick}
          />
        ))}
      </LinksList>
    )
  }
}

Links.propTypes = {
  adminLink: PropTypes.bool,
  deleteLink: PropTypes.func,
  updateUserLink: PropTypes.func,
  addLink: PropTypes.func,
  links: PropTypes.arrayOf(PropTypes.object)
}
export default Links
